function Node () {

}

Node.prototype.type = 'Node'

module.exports = Node
